import { Card, Col, Row } from "antd";
import React from "react";

function InventoryDashboard() {
  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          marginTop: 10,
          boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      >
        <Row>
          <Col>
            <p>Dashboard</p>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default InventoryDashboard;
